import React from "react";
// import { ImageCard } from "../misc/ImageCard";
// import RotatedImageCard from "../misc/RotatedImageCard"

const Hero = () => {
    return (
        <>
            <section className="flex flex-col lg:flex-row items-center justify-between container mx-auto p-4 lg:px-12 text-synthwave shadow rounded-lg lg:py-2 h-min ubuntu-regular my-10">
                {/* Left Section */}
                <div className="flex-1 lg:mr-10">
                    <h2
                        className="text-4xl lg:text-5xl mb-8 ubuntu-regular"
                        data-aos="fade-up" // AOS animation for the heading
                    >
                        Hi there<span className="text-yellow-500">!</span>
                    </h2>
                    <p
                        className="mt-8 text-lg leading-relaxed"
                        data-aos="fade-up"
                        data-aos-delay="150" // Staggered delay for the first paragraph
                    >
                        I’m ‎{" "}
                        <span className="font-medium animate-pulse">
                            Pratham Reet
                        </span>
                        . ‎ I’m a Full Stack Developer, DevOps Engineer, and
                        Cyber Security enthusiast studying Computer Science and
                        Engineering (CSE) at New Horizon College of Engineering
                        (NHCE), set to graduate in 2027. I enjoy building
                        user-friendly web applications, automating processes,
                        and ensuring digital security.
                    </p>
                    <p
                        className="mt-8 text-lg leading-relaxed"
                        data-aos="fade-up"
                        data-aos-delay="150" // Staggered delay for the first paragraph
                    >
                        I love meeting new people and participating in
                        hackathons where I collaborate with others to create
                        innovative solutions. In my downtime, I relax on
                        Discord, chatting about tech and gaming, and I have a
                        passion for video editing.
                    </p>
                    <p
                        className="mt-8 text-lg leading-relaxed"
                        data-aos="fade-up"
                        data-aos-delay="150" // Staggered delay for the first paragraph
                    >
                        As a mentor, I’m dedicated to helping others learn while
                        also working on six startups. I believe in sharing
                        knowledge and making a meaningful impact through my
                        work.
                    </p>
                    <p
                        className="mt-8  mb-10 text-lg leading-relaxed"
                        data-aos="fade-up"
                        data-aos-delay="150" // Staggered delay for the first paragraph
                    >
                        Moving forward, I aim to use my skills in full-stack
                        development, DevOps, and cybersecurity to make a
                        difference in the tech world. Let’s connect and explore
                        new ideas together!
                    </p>

                    <blockquote
                        className="italic text-gray-500 border-l-4 pl-4 border-yellow-500 my-10 font-2xl font-bold"
                        data-aos="fade-up"
                        data-aos-delay="450" // Staggered delay for the blockquote
                    >
                        You'll never truly learn if you're convinced you already
                        know it all.
                    </blockquote>
                </div>
                {/* <div className="hidden lg:block">
                    <ImageCard address="/media/profile/vector.jpg" />
                </div> */}
            </section>
        </>
    );
};

export default Hero;
